import React from 'react';
import { SWUtilityCardProps } from '@/components/pageBuilder/Elements/SWUtilityCard/SWUtilityCard.types';
import SWUtilityCard from '@/components/pageBuilder/Elements/SWUtilityCard/SWUtilityCard';
import { UtilityCardsHeaderContainer, UtilityCardsGrid } from './UtilityCardsHeader.styles';

const UtilityCardsHeader = ({ utilityCards }: { utilityCards: SWUtilityCardProps[] }) => {
  return (
    <UtilityCardsHeaderContainer>
      <UtilityCardsGrid>
        {utilityCards.map((card, index) => (
          <SWUtilityCard key={`card-${card.id}`} {...card} />
        ))}
      </UtilityCardsGrid>
    </UtilityCardsHeaderContainer>
  );
};

export default UtilityCardsHeader;
